import React, { useState } from "react";
import NavBar from "./NavBar";
import Hero from "./Hero";
import About from "./About";
import Services from "./Services";
import Projects from "./Projects";
import Education from "./Education";
import Skills from "./Skills";
import Contact from "./Contact";
import Footer from "./Footer";
import { FaAngleUp } from "react-icons/fa";

const App = () => {
  const [open, setOpen] = useState(false);
  const [showScroll, setScroll] = useState(false);

  const handleOpen = () => {
    setOpen(!open);
  };

  const checkScroll = () => {
    if (!showScroll && window.pageYOffset > 1000) {
      setScroll(true);
    } else if (showScroll && window.pageYOffset < 1000) {
      setScroll(false);
    }
  };

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  window.addEventListener("scroll", checkScroll);

  const displayScroll = showScroll ? "block" : "hidden";

  return (
    <React.Fragment>
      <NavBar open={open} setOpen={handleOpen} />
      <Hero />
      <About />
      <Services />
      <Projects />
      <Education />
      <Skills />
      <Contact />
      <Footer />
      <div className="w-full flex">
        <FaAngleUp
          className={`ml-3 text-xl fixed ${displayScroll} h-8 bottom-0 cursor-pointer`}
          style={{ zIndex: "1000" }}
          onClick={handleScrollTop}
        />
      </div>
    </React.Fragment>
  );
};

export default App;
